import { BaseType } from '../../base/base-type';

export class EmploymentStatusType extends BaseType {}
